import React, { useEffect, useState } from 'react';
import { Button, ListGroup, Modal, Card, Row, Col, Badge } from 'react-bootstrap';

const AdminEmployeesTab = () => {
  const [employees, setEmployees] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const API_URL = process.env.REACT_APP_API_URL;

  // Fetch list of all employees
  const fetchAllEmployees = async () => {
    try {
      const res = await fetch(`${API_URL}/api/admin/employees`);
      const data = await res.json();
      console.log('emp->', data);
      
      setEmployees(data.employees || []);   // FIXED extraction
    } catch (err) {
      console.error('Error fetching employees:', err);
    }
  };

  useEffect(() => { fetchAllEmployees(); }, []);

  // Fetch full employee details by ID
  const fetchEmployeeDetails = async (id) => {
    try {
      const res = await fetch(`${API_URL}/api/admin/employees/${id}`);
      const data = await res.json();
      setSelectedEmployee(data);
    } catch (err) {
      console.error('Error fetching employee details:', err);
    }
  };

  return (
    <div>
      {!selectedEmployee ? (
        <>
          <h4>All Employees</h4>
          <ListGroup>
            {employees.map(e => (
              <ListGroup.Item key={e.employeeId} action onClick={() => fetchEmployeeDetails(e.employeeId)}>
                <strong>{e.name}</strong> - {e.skills}
              </ListGroup.Item>
            ))}
          </ListGroup>
        </>
      ) : (
        <>
          <Button variant="link" onClick={() => setSelectedEmployee(null)}>← Back</Button>

          <Card className="p-4 shadow-sm mt-3">
            <h5>{selectedEmployee.name}</h5>

            <Row className="mt-3">
              <Col md={6}><strong>Email:</strong> {selectedEmployee.email}</Col>
              <Col md={6}><strong>Position:</strong> {selectedEmployee.position}</Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}><strong>Skills:</strong> 
                {selectedEmployee.skills?.split(',').map((s, idx) => (
                  <Badge key={idx} bg="secondary" className="me-1">{s.trim()}</Badge>
                ))}
              </Col>
              <Col md={6}><strong>Rate:</strong> {selectedEmployee.rate}</Col>
            </Row>

            <Row className="mt-3">
              <Col md={6}><strong>Availability:</strong> {selectedEmployee.availability}</Col>
              <Col md={6}><strong>Company:</strong> {selectedEmployee.company_name}</Col>
            </Row>

            <div className="mt-4">
              <h6>Qualification</h6>
              {selectedEmployee.qualification?.map((q, idx) => (
                <p key={idx}>{q.university}, {q.course}, {q.year}</p>
              ))}
            </div>

            <div className="mt-3">
              <h6>Experience</h6>
              {selectedEmployee.experience?.map((exp, idx) => (
                <p key={idx}>{exp.company} - {exp.role} ({exp.from} to {exp.to})</p>
              ))}
            </div>

            {selectedEmployee.cv?.data && (
              <div className="mt-3">
                <h6>CV Preview</h6>
                <embed
                  src={`data:${selectedEmployee.cv.contentType};base64,${btoa(
                    new Uint8Array(selectedEmployee.cv.data.data).reduce((data, byte) => data + String.fromCharCode(byte), '')
                  )}`}
                  type="application/pdf"
                  width="100%" height="400px"
                />
              </div>
            )}

            <div className="text-center mt-4">
              <Button variant="primary">Applicants</Button>
            </div>
          </Card>
        </>
      )}
    </div>
  );
};

export default AdminEmployeesTab;
